<table class="table issue-tracker clickable dt-responsive dataTable no-footer dtr-inline table-color">
  <thead>
    <tr>
      <th *ngFor="let col of columnNames">
        {{ col.renderColumnDisplay }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let col of [].constructor(numberOfRows)">
      <td *ngFor="let col of [].constructor(columnsCount)">
        <feature-loading-skeleton height="2rem"></feature-loading-skeleton>
      </td>
    </tr>
  </tbody>
</table>
